<div class="row">
    <div class="col-sm-12">
        <ng-content select="[rowContent]"></ng-content>
    </div>
</div>